import { GridLegacy as Grid, Typography } from '@mui/material'
import { OutcomeIcon, getOutcomeText } from 'components/core/task/outcome'
import { OutcomeStyles } from 'components/core/task/outcome/styles'
import { getShortString } from 'components/core/time/display'
import { TaskValue } from 'lib/actions/task'
import { CertifyOutcome, GrantOutcome, RevokeOutcome } from 'pbts/c1/api/task/v1/task'
import { Timestamp as pbtsTimestamp } from 'pbts/google/protobuf/timestamp'
import { useIntl } from 'react-intl'

const ResolutionDate = ({ outcomeTime }: { outcomeTime?: pbtsTimestamp }): React.ReactElement => {
    let localeDateString = ''
    if (outcomeTime) {
        localeDateString = getShortString({ d: pbtsTimestamp.toDate(outcomeTime), variant: 'date_only' })
    }

    return <Typography variant="caption">{localeDateString}</Typography>
}

export const Outcome = ({
    task,
    showResolutionDate = true,
}: {
    task: TaskValue
    showResolutionDate?: boolean
}): React.ReactElement | null => {
    const intl = useIntl()
    const typ = task?.type?.taskType

    let outcome: CertifyOutcome | GrantOutcome | RevokeOutcome
    let outcomeTime
    switch (typ?.oneofKind) {
        case 'certify':
            outcome = typ.certify.outcome
            outcomeTime = typ.certify.outcomeTime
            break
        case 'grant':
            outcome = typ.grant.outcome
            outcomeTime = typ.grant.outcomeTime
            break
        case 'revoke':
            outcome = typ.revoke.outcome
            outcomeTime = typ.revoke.outcomeTime
            break
        default:
            return null
    }

    return (
        <Grid item container direction="row" alignItems="center" wrap="nowrap">
            <Grid item sx={OutcomeStyles.iconContainer}>
                <OutcomeIcon outcome={outcome} applyStyles />
            </Grid>
            <Grid item>
                <Typography>{getOutcomeText(task, intl)}</Typography>
                {showResolutionDate && <ResolutionDate outcomeTime={outcomeTime} />}
            </Grid>
        </Grid>
    )
}
